<template>
  <v-container style="max-width: 1300px" class="mx-auto">
    <v-row class="mx-1">
      <h4>Санал асуулгууд</h4>
      <v-spacer></v-spacer>
      <v-btn
        v-if="
          userProfile != null &&
          (userProfile.role == 'teacher' ||
            userProfile.role == 'sts' ||
            userProfile.role == 'manager' ||
            userProfile.role == 'admin')
        "
        color="primary"
        @click="_addNewAsuulga"
        >Асуулга+
      </v-btn>
    </v-row>
    <v-row class="mb-10" v-if="items != null && items.length > 0">
      <v-card
        v-for="(itm, nindex) in items"
        v-bind:key="nindex"
        class="mx-4 my-4 d-flex flex-column"
        width="400"
      >
        <!-- <v-img height="200" src="/assets/img/items.png"></v-img> -->

        <v-card-title style="word-break: normal; line-height: 1.3"
          >{{ getXSubStr(itm.title, 100) }}
        </v-card-title>
        <!--  
        <v-card-text>
          {{ itm.userId }},
          <span style="color: red">{{ userProfile.customer.id }}</span>
        </v-card-text> -->
        <v-card-text class="d-flex justify-space-between" v-if="itm.createdAt">
          {{ itm.createdAt.toDate() | moment("YYYY/MM/DD, h:mm") }}
          <span class="primary--text">{{ itm.createdByName }}</span>
        </v-card-text>
        <v-card-text class="py-0 my-0" v-if="itm.description">
          <div>
            <!-- {{ getXSubStr(itm.description, 100) }} -->
            {{itm.description}}
          </div>
        </v-card-text>
        <v-card-text class="py-0 my-0">
          <v-container class="text-center" v-if="itm.videoUrl != null">
            <iframe
              width="100%"
              height="160"
              :src="getXYoutubeIframe(itm.videoUrl)"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-container>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            color="error lighten-2"
            v-if="itm.userId == userProfile.customer.id"
            text
            @click="_deleteNews(itm)"
          >
            <v-icon left> mdi-delete </v-icon>
            Устгаx
          </v-btn>
          <v-btn
            color="error lighten-2"
            v-else-if="
              userProfile.role == 'admin' ||
              userProfile.role == 'manager' ||
              userProfile.role == 'sts' ||
              (itm.createdBy != null &&
                itm.createdBy != undefined &&
                userProfile.customer.path == itm.createdBy.path)
            "
            text
            @click="_deleteNews(itm)"
          >
            <v-icon left> mdi-delete </v-icon>
            Устгаx
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            text
            @click="_goDetail(itm)"
            v-if="_isSubmitted(itm) != true"
          >
            <small>Дэлгэрэнгүй</small>
          </v-btn>
          <v-btn color="#FF5252" dark v-else>
            <small>Санал өгсөн</small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
    <div class="modal fade" id="schoolModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Асуулга нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <input
                  v-model.trim="object.title"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Гарчиг"
                />
              </div>

              <div class="form-group">
                <textarea
                  rows="10"
                  v-model.trim="object.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Тайлбар мэдээлэл"
                />
              </div>
              <div class="form-group">
                <input
                  v-model.trim="object.videoUrl"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Видео линк"
                />
              </div>

              <div class="form-group">
                <div class="">
                  <input
                    type="checkbox"
                    id="publishedCheck"
                    v-model="object.published"
                  />
                  <label for="publishedCheck"
                    >Нээлттэй<span class="text-info">
                      /Нээлттэй болгосоноор энэ мэдээллийг ажилтангууд харах
                      боломжтой./</span
                    ></label
                  >
                </div>
              </div>
              <div class="form-group">
                <div class="">
                  <input
                    type="checkbox"
                    v-model="object.forAllTeacher"
                    class="mr-2"
                  />
                  <label class="mr-4">Багш нарт</label>
                  <input
                    type="checkbox"
                    v-model="object.forAllStudent"
                    class="mr-2"
                  />
                  <label class="mr-4">Сурагчдад</label>
                  <input
                    type="checkbox"
                    v-model="object.forParent"
                    class="mr-2"
                  />
                  <label>Эцэг эx</label>
                </div>
              </div>
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="_saveNewAsuulga"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import myfunction from "../../global/myfunction.js";
const fb = require("../../../firebaseConfig.js");

export default {
  data() {
    return {
      items: [],
      object: {
        title: null,
        description: null,
        published: false,
      },
      customerData: null,
      loading: false,
      school: null,
      myAsuulguud: null,
    };
  },
  mixins: [myfunction],
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  methods: {
    _isSubmitted(asuulga) {
      console.log(this.myAsuulguud);
      if (this.items != null) {
        for (const asuulga of this.items) {
          if (this.myAsuulguud != null) {
            for (const myasuulga of this.myAsuulguud) {
              if (asuulga.id == myasuulga.id) return true;
            }
          }
        }
      }
      return false;
    },
    _makePublish(items) {
      fb.db.collection(this.asuulgaPath).doc(items.id).update({
        published: !items.published,
      });
    },
    async _getData() {
      var dat = await fb.db.doc("schools/" + this.schoolId).get();

      if (dat.exists) {
        this.school = dat.data();
        this.school.id = dat.id;
        this.school.ref = dat.ref;
      }
      console.log(this.schoolId, this.school);
      var dat = await this.userProfile.customer.get();
      let data = dat.data();
      data.id = dat.id;
      data.ref = dat.ref;
      this.customerData = data;

      var myAsuulga = await this.customerData.ref.collection("asuulga").get();
      if (myAsuulga.empty == false) {
        this.myAsuulguud = [];
        for (const doc of myAsuulga.docs) {
          let asuu = doc.data();
          asuu.id = doc.id;
          asuu.ref = doc.ref;
          this.myAsuulguud.push(asuu);
        }
      }

      this.asuulgaPath = "schools/" + this.schoolId + "/asuulga";
      fb.db
        .collection(this.asuulgaPath)
        // .where("type", "==", fb.db.doc(this.typePath))
        .orderBy("createdAt", "desc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;

            if (object.published == undefined || object.published == null)
              object.published = false;
            if (object.notified == undefined || object.notified == null)
              object.notified = false;

            if (
              this.userProfile.role == "admin" ||
              this.userProfile.role == "sts" ||
              this.userProfile.role == "manager"
            ) {
              this.items.push(object);
            } else {
              if (
                object.createdBy != undefined &&
                object.createdBy != null &&
                this.userProfile.customer != undefined &&
                this.userProfile.customer != null &&
                object.createdBy.path == this.userProfile.customer.path
              ) {
              } else {
                if (
                  object.forAllTeacher &&
                  this.userProfile.role == "teacher"
                ) {
                  this.items.push(object);
                } else {
                  if (
                    this.userProfile.role == "teacher" &&
                    object.userclasses != null
                  ) {
                    // for (var nn of object.userclasses) {
                    //   if (nn.ref.path == this.customerData.programRef.path)
                    //     this.items.push(nws);
                    // } TODOX
                  }
                }

                if (
                  object.forAllStudent &&
                  this.userProfile.role == "student"
                ) {
                  this.items.push(object);
                } else {
                  console.log();
                  if (
                    this.userProfile.role == "student" &&
                    object.userclasses != null
                  ) {
                    for (var nn of object.userclasses) {
                      if (
                        nn.programRef &&
                        nn.programRef.path ==
                          this.customerData[
                            "program-" + this.school.currentYear
                          ].path
                      ) {
                        this.items.push(object);
                        break;
                      }
                    }
                  }
                }
              }
            }
            //this.items.push(object);
          });
        });
    },
    _goDetail(item) {
      if (item.viewCount) {
        fb.db
          .collection(this.asuulgaPath)
          .doc(item.id)
          .update({
            viewCount: item.viewCount + 1,
          });
      } else {
        fb.db.collection(this.asuulgaPath).doc(item.id).update({
          viewCount: 1,
        });
      }
      this.$router.push({
        name: "XADetail",
        params: { schoolId: this.schoolId, asuulgaId: item.id },
      });
    },
    _saveNewAsuulga() {
      if (
        this.object != null &&
        this.object.title != null &&
        this.object.title != ""
      ) {
        if (
          this.object.videoUrl &&
          this.object.videoUrl.toLowerCase().indexOf("youtube") == -1
        ) {
          alert("Та заавал youtube бичлэг оруулна уу");
          return;
        }
        if (this.object.id != null && this.object.id != "") {
          fb.db
            .collection(this.asuulgaPath)
            .doc(this.object.id)
            .update({
              title: this.object.title,
              description: this.object.description,
              published: this.object.published,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              modifiedBy: this.userProfile.customer,
              createdBy: this.userProfile.customer,
              // /createdByName: this.userProfile.customer,
              //type: fb.db.doc(this.typePath),
              videoUrl: this.object.videoUrl ? this.object.videoUrl : null,
              // 'when': this.object.when!=undefined?this.object.when:null,
              // 'where': this.object.where!=undefined?this.object.where:null,
              // 'to': this.object.to!=undefined?this.object.to:null,
            });
        } else {
          this.object.createdAt = new Date();
          this.object.userId = this.$store.getters.currentUser.uid;
          this.object.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          this.object.createdBy = this.userProfile.customer;
          this.object.createdByName =
            this.userProfile.name != null ? this.userProfile.name : "";

          fb.db
            .collection("schools")
            .doc("xUSN7smB3EcLwDYhs1Y9")
            .collection("asuulga")
            .doc()
            .set(this.object)
            .then(() => {
              console.log("OK");
            });

          // console.log(this.school)
        }
        this.object = {
          title: null,
          published: false,
          description: null,
          when: null,
          where: null,
          to: null,
        };
      } else {
        alert("Та гарчиг, тайлбараа оруулна уу");
      }
    },
    _editNews(items) {
      this.object = Object.assign({}, items);
      $("#schoolModal").modal("toggle");
    },
    _addNewAsuulga() {
      console.log(this.schoolId);
      this.object = {};
      $("#schoolModal").modal("toggle");
    },
    _deleteNews(items) {
      var result = confirm("Та " + items.title + " устгах уу?");
      if (result) {
        fb.db.collection(this.asuulgaPath).doc(items.id).delete();
      }
    },
    _sendNotif(data) {
      if (this.asuulgaPath && data && data.id) {
        var result = confirm("Та " + data.title + " зарлал илгээх үү?");
        if (result) {
          fb.db.collection(this.asuulgaPath).doc(data.id).update({
            notified: !data.notified,
          });
        }
      }
    },
  },
  created() {
    console.log(this.schoolId);
    this._getData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
